import React from 'react';
import preventDefault, { FormValues } from 'app/gamma/src/util/prevent-default';

import styles from './change-password.less';

import { forTemplate } from 'app/common/lib/util/i18n';
const format = forTemplate('popover_change_set_password');
const formatPasswordError = forTemplate('password error');

interface ChangePasswordProps {
  onChangePassword: (arg: React.FormEvent<Element> | FormValues) => void;
  hasPassword: boolean;
  errors: string[];
}

export const ChangePassword: React.FunctionComponent<ChangePasswordProps> = ({
  onChangePassword,
  hasPassword,
  errors,
}) => (
  <form
    className={styles.form}
    onSubmit={preventDefault(onChangePassword, true)}
  >
    {hasPassword && [
      <label key="oldPasswordLabel" htmlFor="oldPassword">
        {format('old-password')}
      </label>,
      <input
        key="oldPasswordInput"
        id="oldPassword"
        type="password"
        name="oldPassword"
      />,
    ]}

    <label htmlFor="password1">
      {format(hasPassword ? 'new-password' : 'password')}
    </label>
    <input id="password1" type="password" name="password1" />

    <label htmlFor="password2">
      {format(hasPassword ? 'new-password-again' : 'password-again')}
    </label>
    <input id="password2" type="password" name="password2" />

    {errors.map((error) => (
      <p className="error">{formatPasswordError(error)}</p>
    ))}

    <button type="submit">{format('save')}</button>

    {!hasPassword && (
      <div className={styles.noPasswordFooter}>
        <hr />
        <div className={styles.grayText}>
          {formatPasswordError(
            'you-havent-set-a-password-yet-you-can-set-a-password-so-you-can-log-onto-trello-with-just-your-username-or-email-address',
          )}
        </div>
      </div>
    )}
  </form>
);
